import { useAuth } from '../auth/AuthProvider';
import LeftNavigation from './LeftNavigation';

export default function MainLayout({ children }) {
  const { user, approved } = useAuth();

  // Only show the layout with navigation for authenticated and approved users
  if (!user || !approved) {
    return children;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <LeftNavigation />
      <main className="flex-1 overflow-auto">
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
}